import React from "react";
import { useRef, type FC } from "react"
import { useInView } from "@/hooks/reveal-in-view";
import { Image } from "../image";
import type { AlinaNemykinaProps } from "@/types/components/p2p-money-abroad/alinaNemykina"
import { ContentManager } from "../content-manager";
import SplitTextAnimation from "../split-text-animation";
import { Link } from "../link";

export const AlinaNemykina: FC<AlinaNemykinaProps> = ({alinaNemykina}) => {

  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "0px 0px 25% 0px" });
  const [showMore, setShowMore] = React.useState(false);

  return (
    <section>
      <div className="wrapper">
        <div className="alinaNemykina">
          <div className="alinaNemykina--info-container">
            <Image
              src={alinaNemykina.image as any}
              alt={alinaNemykina.name}
              className="alinaNemykina--image"
              animateInView
            />
          </div>
          <div className="alinaNemykina--info">
            <div>
              <SplitTextAnimation
                htmlElement={
                  <h2
                    id={`${alinaNemykina.name.toLowerCase().replace(/ /g, "-")}`}
                    className="alinaNemykina--name"
                  >
                    {alinaNemykina.name}
                  </h2>
                }
                isInView={isInView}
              />
              <div ref={ref} className="alinaNemykina--role">
                {alinaNemykina.role}
              </div>
            </div>
            <ContentManager
              content={alinaNemykina.description}
              className="alinaNemykina--description"
            />
            {alinaNemykina.linkedIn && (
              <div className="">
                <Link
                  href={alinaNemykina.linkedIn}
                  className="alinaNemykina--makeACall"
                  target="_blank"
                >
                  <span>{"Book a call with Alina"}</span>
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  )
}